/* global DetailsModal, CompareUtil */

customElements.whenDefined('details-modal').then(() => {
  class CompareModal extends DetailsModal {
    constructor() {
      super();
      this.compareContainer = this.querySelector('.compare-container');
      this.compareArea = this.compareContainer.querySelector('.js-compare-area');
      this.loadingSpinner = this.compareContainer.querySelector('.loading-spinner');
      this.closeButton = this.querySelectorAll('.js-compare-close');

      this.bindEvents();

      // this.open();
    }

    disconnectedCallback() {
      document.removeEventListener('focusin', this.clickHandler);

      if (Shopify.designMode) {
        document.removeEventListener('shopify:section:load', CompareModal.handleSectionChange);
        document.removeEventListener('on:product-compare:reload', this.compareReloadHandler);
      }
    }

    bindEvents() {
      this.addEventListener('on:product-compare-modal:open', this.open);

      this.clickHandler = this.handleClick.bind(this);
      document.addEventListener('click', this.clickHandler);

      this.closeButton.forEach((closeButton) => {
        closeButton.addEventListener('click', this.closePopup.bind(this));
      });

      // Refresh the compare when the Compare section get updated
      if (Shopify.designMode) {
        this.compareReloadHandler = this.renderCompareTable.bind(this);
        document.addEventListener('shopify:section:load', CompareModal.handleSectionChange);
        document.addEventListener('on:product-compare:reload', this.compareReloadHandler);
      }
    }

    /**
     * Handles a 'click' event for remove from compare
     * @param {object} evt - Event object
     */
    handleClick(evt) {
      if (evt.target.classList.contains('js-compare-col-remove')) {
        evt.preventDefault();

        CompareUtil.removeFromCompare(evt.target.dataset.productId.toString(), true);

        const compareCount = CompareUtil.getCompareCount();
        this.compareContainer.dataset.compareCount = compareCount;
        if (compareCount === 1) {
          this.closePopup();
        }
      }
    }

    closePopup(){
      document.querySelector('html')?.classList.remove('overflow-scroll');
      super.close();

      const compare_filters = this.querySelector('compare-filters');
      compare_filters && compare_filters.dispatchEvent(new CustomEvent('on:compare-modal:closed'), { bubbles: true });
      compare_filters && compare_filters?.classList.add('hidden');
    }

    /**
     * Opens the compare modal
     */
    open() {
      this.modal.classList.remove('hidden');
      this.renderCompareTable();
      super.open();
      document.querySelector('html')?.classList.add('overflow-scroll');
      document.querySelector('.compare-modal-close')?.classList.remove('hidden');
    }

    /**
     * Hook into the super function to hide the modal when it's finished closing
     * @param {object} evt - Event object
     */
    handleTransitionEnd(evt) {
      super.handleTransitionEnd(evt);
      if (this.modal.open === false) {
        this.modal.classList.add('hidden');
      }
    }

    /**
     * Triggers a refresh the compare table based on Theme Editor events
     * @param {object} evt - Event object
     */
    static handleSectionChange(evt) {
      if (evt.target.matches('.cc-compare')) {
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('on:product-compare:reload'));
        }, 1000);
      }
    }

    /**
     * Renders the compare table
     */
    async renderCompareTable() {
      // Reset the previous state if applicable
      this.loadingSpinner.removeAttribute('hidden');
      this.loadingSpinner.removeAttribute('aria-hidden');
      this.compareArea.classList.remove('revealable--in');
      this.compareArea.innerHTML = '';

      // Get the compare products
      const compareProducts = CompareUtil.getSelectedProducts();
      if (compareProducts) {
        this.compareContainer.dataset.compareCount = compareProducts.length;

        // Transform the HTML into something flexbox friendly
        const compareProductHtmlArr = await CompareModal.getCompareProducts(compareProducts);
        const compareFieldsArr = [];

        if (compareProductHtmlArr.length > 0) {
          compareProductHtmlArr.forEach((compareProductHtml) => {
            const responseHTML = document.implementation.createHTMLDocument();
            responseHTML.documentElement.innerHTML = compareProductHtml; // eslint-disable-line

            responseHTML.querySelectorAll('.shopify-section > div').forEach((compareField) => {
              if (!compareFieldsArr[compareField.dataset.compareKey]) {
                compareFieldsArr[compareField.dataset.compareKey] = [];
              }
              compareFieldsArr[compareField.dataset.compareKey].push(compareField);
            });
          });

          // Create the compare flex
          const compareElem = document.createElement('div');
          compareElem.className = 'compare-temp';

          Object.entries(compareFieldsArr).forEach(([key, value]) => {
            // If we can show empty metafield rows, or all metafields are not empty
            if (theme.settings.compareShowEmptyMetafields
              || !value.every((elem) => !!elem.dataset.isEmptyMetafield)) {

              const compareRow = document.createElement('div');
              compareRow.className = `compare-row compare-row--${
                key.includes('metafield') ? 'metafield' : key.replace('compare-', '')
              }`;
              
              value.forEach((elem) => compareRow.appendChild(elem));
              compareElem.appendChild(compareRow);
              // if (key.includes('images')) {
              //   const compareRowTitle = document.createElement('div');
              //   compareRowTitle.className = `compare-row compare-row--title`;
              // }
            }
          });

          this.compareArea.innerHTML = compareElem.innerHTML;
          this.compareFilters = compareFieldsArr;
          this.querySelector('compare-filters')?.buildFilters();
        } else {
          this.compareFilters = null;
          this.compareArea.innerHTML = `Unable to compare products.${
            Shopify.designMode
              ? ' Ensure the Product Compare section is enabled.'
              : ' Please try again later.'
          }`;
        }

        // Timeout to trigger CSS transition
        setTimeout(() => {
          this.loadingSpinner.setAttribute('hidden', 'true');
          this.loadingSpinner.setAttribute('aria-hidden', 'true');
          this.compareArea.classList.add('revealable--in');

        }, 100);
      }
    }

    getCompareFilters(){
      return this.compareFilters;
    }

    /**
     * Fetches an array of html for each of the compare products, using the section rendering API
     * @param {Array} compareProducts - An array of product objects to compare
     */
    static async getCompareProducts(compareProducts) {
      const tempHtml = [];
      await Promise.all(
        compareProducts.map(async (product) => {
          const response = await fetch(`${product.url}`);
          if (response.ok) {
            const tmpl = document.createElement('template');
            tmpl.innerHTML = await response.text();
            const compareEl = tmpl.content.querySelector('.cc-compare');
            if (compareEl) tempHtml[product.id] = compareEl.outerHTML;
          }
        })
      );

      // Return the html in the order they were added to the compare
      const returnHtml = [];
      if (Object.keys(tempHtml).length > 0) {
        compareProducts.forEach((product) => returnHtml.push(tempHtml[product.id]));
      }

      return returnHtml;
    }
  }

  customElements.define('compare-modal', CompareModal);
});


customElements.whenDefined('compare-modal').then(() => {
  class CompareFilters extends HTMLElement {

    constructor(){
      super();
      this.filters = null;
      this.form = this.querySelector('compare-filters');
      
      this.init();
      this.addEventListener('on:compare-modal:closed', this.removeEventListeners.bind(this));
    }

    removeEventListeners() {
      this.querySelectorAll('input[type="checkbox"]')?.forEach(inp => {
        inp.checked = true;
      });
    }

    disconnectedCallback() {
      this.filtersBtn && this.filtersBtn.removeEventListener('click', this.toggleCompareFilters.bind(this))
      this.removeEventListener('input', debounce(this.handleFilterChange.bind(this), 100));
    }

    init() {
      this.compareModal = this.closest('compare-modal');
      this.compareArea = this.compareModal && this.compareModal.querySelector('.js-compare-area');
      this.filtersBtn = this.querySelector('.js-filters-btn');
      this.filtersBtn && this.filtersBtn.addEventListener('click', this.toggleCompareFilters.bind(this))
      
      this.addEventListener('input', debounce(this.handleFilterChange.bind(this), 100));
    }

    buildFilters() {
      this.filtersData = this.compareModal.getCompareFilters();

      if(!this.filtersData) return

      // Product Information Filters
      let filterDisclosureNode = this.getTemaplteNode('compare-filter-template');
      let filtersList = filterDisclosureNode.querySelector('.js-filters-list');

      // Power Filters
      let filterPowerDisclosureNode = this.getTemaplteNode('compare-filter-template');
      filterPowerDisclosureNode.querySelector('.js-filter-heading').textContent = 'Power';
      let filtersPowerList = filterPowerDisclosureNode.querySelector('.js-filters-list');

      // Additional Filters
      let filterAdditionalDisclosureNode = this.getTemaplteNode('compare-filter-template');
      filterAdditionalDisclosureNode.querySelector('.js-filter-heading').textContent = 'Additional';
      let filtersAdditionalList = filterAdditionalDisclosureNode.querySelector('.js-filters-list');
      
      Object.entries(this.filtersData).forEach(([key, value]) => {
        // Product Information filters
        if(!key.includes('metafield') && !key.includes('heading') && !key.includes('remove') && !key.includes('price') && !key.includes('image')){
          const filterData = {
            key,
            title: this.buildFilterTitle(key),
          };

          this.buildFilterList(filterData, filtersList);

          // Disabled vendor and title filters
          // if(key.includes('compare-image')){
          //   // Add filter for vendor
          //   let filterData = {
          //     key: 'compare-vendor',
          //     title: "Vendor",
          //   };
  
          //   this.buildFilterList(filterData, filtersList);
          //   // Add filter for title
          //   filterData = {
          //     key: 'compare-title',
          //     title: "Title",
          //   };
  
          //   this.buildFilterList(filterData, filtersList);
          // }
          // Disabled prices filter
          // if(key.includes('compare-rating')){
          //   // Add custom filter for price
          //   let filterData = {
          //     key: 'compare-price',
          //     title: "Prices",
          //   };
  
          //   this.buildFilterList(filterData, filtersList);
          // }
        }

        if(key.includes('metafield')){
          const filterData = {
            key,
            title: this.buildFilterTitle(key),
          };
          // check for empty metafields
          if(isNaN(filterData.title)) {

            if(this.powerFilter(key)) {
              // Power filters
              this.buildFilterList(filterData, filtersPowerList);
            } else if(this.productFilter(key)) {
              // Product Information filters
              this.buildFilterList(filterData, filtersList);
            } else {
              // Additional filters
              this.buildFilterList(filterData, filtersAdditionalList);
            }
          }
        }
      });

      const customFilters = this.querySelector('.js-custom-filters');

      customFilters && (customFilters.innerHTML = '');
      customFilters && customFilters.append(filterDisclosureNode);
      customFilters && customFilters.append(filterPowerDisclosureNode);
      customFilters && customFilters.append(filterAdditionalDisclosureNode);

      this.removeEmptyParagraphs();
      this.showCompareFilters();
      this.checkContentHeight();

      this.addEventListeners();
    }

    productFilter(key) {
      let product = false;

      if(key.includes('description') ||
        key.includes('-manufactured_in') ||
        key.includes('-dimensions_h_x_w_x_d_') ||
        key.includes('-weight') ||
        key.includes('-cable_length') ||
        key.includes('-mounting_type') ||
        key.includes('-paymentmethod') ||
        key.includes('-port_type') ||
        key.includes('-brand_compatibility')
      ) {
        product = true;
      }

      return product;
    }

    powerFilter(key) {
      let power = false;
      if(key.includes('-charger_amps') ||
        key.includes('-voltage') || 
        key.includes('-power') || 
        key.includes('-wire_type') ||
        key.includes('-amp_range')
      ) {
        power = true;
      }

      return power;
    }

    buildFilterList(filterData, list) {
      const li = this.getTemaplteNode('filter-list', filterData);

      if(!this.checkForEmptyMetafield(filterData.key)) return

      li.querySelector('.js-filter-input').dataset.filterSelector = filterData.key;
      li.querySelector('.js-filter-title').innerHTML = filterData.title;
      li.querySelector('input').setAttribute('id', filterData.key + new Date().getTime());
      li.querySelector('label').htmlFor = filterData.key + new Date().getTime();
      list.append(li);
  
 var popupOpenButtons = document.querySelectorAll('a[title="Charging Reference Table"]');
  var popupInner = document.querySelector(".popup-inner");
  var popupBody = document.querySelector(".popup-body");
  var closeButtons = document.querySelectorAll(".close-btn, .pop-overlay");

  popupOpenButtons.forEach(function (button) {
    button.addEventListener("click", function (event) {
event.preventDefault();
      popupBody.style.display = "block";
      setTimeout(function () {
        popupInner.classList.add("open_popup_inner");
      }, 300);
    });
  });

  closeButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      popupInner.classList.remove("open_popup_inner");
      setTimeout(function () {
        popupBody.style.display = "none";
      }, 300);
    });
  });

    }

    checkForEmptyMetafield(key) {
      const filters = this.compareArea.querySelectorAll(`[data-compare-key="${key}"]`);

      if(filters.length > 0) return true;

      return false
    }

    buildFilterTitle(key) {
      if(!key) return 'Default Title';
      let title = key.toLowerCase()
      
      title = key.replace('compare-metafield', '').replace('compare', '').replaceAll('-', ' ').replaceAll('_', ' ')

      if(key.includes('paymentmethod')){
        title = 'Payment Method'
      } else if(key.includes('-mounting_type')){
        title = 'Mount Type'
      } else if(key.includes('-brand_compatibility')){
        title = 'Compatible With'
      } else if(key.includes('-dimensions_h_x_w_x_d_')){
        title = 'Dimensions (H X W X D)'
      } else if(key.includes('-weatherproof_rating')){
        title = 'Weather Rating'
      } else if(key.includes('-smart_home_compatibility')){
        title = 'Network Connectivity'
      } else if(key.includes('-charger_amps')){
        title = 'Charger Amps'
      } else if(key.includes('-wire_type')){
        title = 'Electrical Connection'
      } else if(key.includes('-variants')){
        title = 'Options'
      }

      return title
    }

    getTemaplteNode(templateName) {
      let template = document.querySelector(`template.${templateName}`);
      let node = template.content.firstElementChild.cloneNode(true);
      return node
    }

    showCompareFilters(){
      this.classList.remove('hidden')
    }

    addEventListeners() {
      const addToCartBtns = this.compareModal && this.compareModal.querySelectorAll('.card__quick-add button.btn');
      addToCartBtns && addToCartBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          setTimeout(() => {
            this.compareModal.closePopup();
          }, 200);
        })
      })

      const show_more_btn = document.querySelectorAll('.show-more-btn');
      show_more_btn.forEach(el => {
        el.addEventListener('click', (evt) => this.toggleContent(evt.target));
      });
    }

    toggleCompareFilters() {
      const form = this.querySelector('#compare-filters');

      if(form.classList.contains('mobile-hidden')){
        form.classList.remove('mobile-hidden')
      } else {
        form.classList.add('mobile-hidden')
      }
    }

    /**
     * Handles 'input' events on the filters
     * @param {object} evt - Event object.
     */
    handleFilterChange(evt) {
      const { target } = evt;
      const selector = target.dataset.filterSelector;

      if(selector) {
        if(selector == 'compare-price'){
          this.toggleFilterResults('compare-retail_price', target.checked);
          this.toggleFilterResults('compare-list_price', target.checked);
          return
        }

        this.toggleFilterResults(selector, target.checked)
      }
    }

    toggleFilterResults(selector, show = true) {
      if(!selector || !this.compareArea) return

      const elements = this.compareArea.querySelectorAll(`[data-compare-key="${selector}"]`);

      elements.forEach(el => {
        show ? el.classList.remove('hidden') : el.classList.add('hidden')
      })
    }

    /**
     * Handles 'click' events on the filters.
     * @param {object} evt - Event object.
     */
    handleFiltersClick(evt) {
      const { target } = evt;
    }

    removeEmptyParagraphs() {
      document.querySelector('.js-compare-area')?.querySelectorAll('p')?.forEach(p => p.textContent == String.fromCharCode(160) ? p.remove(): null);
    }

    toggleContent(btn) {
      const content = btn.closest('[data-compare-key="compare-description"]');

      if (content.style.maxHeight) {
        content.style.maxHeight = null;
        content.classList.remove('description-exapanded');
        btn.textContent = 'See More';
      } else {
        content.style.maxHeight = '100%';
        content.classList.add('description-exapanded');
        btn.textContent = 'See Less';
      }
    }

    checkContentHeight() {
      const content = document.querySelectorAll('.js-compare-area [data-compare-key="compare-description"]');
      content.forEach(c => {
        const show_more_btn = c.querySelector('.show-more-btn');
        
        if(show_more_btn){
          if (c.scrollHeight <= 350) {
            show_more_btn.style.display = 'none';
          } else {
            show_more_btn.style.display = 'block';
          }
        }
      })
    }
  }

  customElements.define('compare-filters', CompareFilters);
})
